import {createSelector} from '@reduxjs/toolkit'

import {RootState} from './interfaces'

/** 적립 포인트 Selector */
export const rewardPointSelector = (state: RootState) => state.rewardPoint

/** 적립 포인트 반환 */
export const rewardPointAmountSelector = (state: RootState) => state.rewardPoint.amount

/** 적립 포인트 API 상태 */
export const rewardPointApiStatusSelector = (state: RootState) => state.rewardPoint.status

/** 적립포인트 상세정보 */
export const rewardDescriptionsSelector = (state: RootState) => state.rewardPoint.descriptions

/**
 * 적립포인트 내 바우처포인트 보유여부
 */
export const rewardDescriptionInfoSelector = createSelector(rewardDescriptionsSelector, (descriptions) => {
    const hasVoucher = descriptions.some((description) => description.cashType === 'VOUCHER')

    return {
        hasVoucher,
    }
})
